import script from "./TextBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextBlock.vue?vue&type=script&lang=ts&setup=true"

import "./TextBlock.vue?vue&type=style&index=0&id=237e374e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237e374e"]])

export default __exports__